import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { LanguageProvider, isValidLangParam, LANG_KEY, DEFAULT_LANG } from "@/lib/i18n";
import LangLayout from "@/components/layout/LangLayout";
import Home from "@/pages/Home";
import Learn from "@/pages/Learn";
import LessonDetail from "@/pages/LessonDetail";
import Play from "@/pages/Play";
import Stories from "@/pages/Stories";
import StoryDetail from "@/pages/StoryDetail";
import Impact from "@/pages/Impact";
import About from "@/pages/About";
import Token from "@/pages/Token";
import Community from "@/pages/Community";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import { Toaster } from "@/components/ui/sonner";

function RootRedirect() {
  let stored = DEFAULT_LANG;
  try {
    const s = localStorage.getItem(LANG_KEY);
    if (s && isValidLangParam(s)) stored = s;
  } catch {}
  return <Navigate to={`/${stored}`} replace />;
}

function LangGate() {
  const { lang } = useParams();
  if (!isValidLangParam(lang)) return <Navigate to={`/${DEFAULT_LANG}`} replace />;
  return (
    <LanguageProvider param={lang}>
      <LangLayout />
    </LanguageProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/:lang" element={<LangGate />}>
            <Route index element={<Home />} />
            <Route path="learn" element={<Learn />} />
            <Route path="learn/:slug" element={<LessonDetail />} />
            <Route path="play" element={<Play />} />
            <Route path="stories" element={<Stories />} />
            <Route path="stories/:slug" element={<StoryDetail />} />
            <Route path="impact" element={<Impact />} />
            <Route path="about" element={<About />} />
            <Route path="token" element={<Token />} />
            <Route path="community" element={<Community />} />
            <Route path="faq" element={<Faq />} />
            <Route path="legal" element={<Legal />} />
            <Route path="legal/:doc" element={<Legal />} />
          </Route>
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
